import { InjectionToken } from '@angular/core';

export const A7_SOCKET_HOST = new InjectionToken<string>('A7_SOCKET_HOST');
